import React, {PropTypes as T} from 'react';
import {ModalHeader} from '../../common/modal';
import Button from '../../common/button';
import ModalCautionIcon from '../../common/icons/icon_modal_caution';
import ModalCloseIcon from '../../common/icons/icon_close2';

export default class CloseableIconErrorHeader extends React.Component {
  static propTypes = {
    onClose: T.func,
    title: T.string
  };

  render () {
    return (
      <ModalHeader isError>
        <div className="modal__header__icon__wrapper">
          <ModalCautionIcon className="modal__header__icon" />
        </div>
        <div className="modal__header_title">{this.props.title}</div>
        <Button icon onClick={this.props.onClose} data-component="modal__header__close_icon">
          <ModalCloseIcon className="modal__header__close_icon" />
        </Button>
      </ModalHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/modal/closeable_icon_error_header.js